import React from "react";
import I18n from "lib/i18n";
import PropTypes from "prop-types";

const AnalyticsLink = ({ visible }) => {
  if (visible) {
    return (
      <React.Fragment>
        <li className="metrics">
          <a href="https://analytics.theconversation.com/">{I18n.t("top_bar.label.analytics")}</a>
        </li>
      </React.Fragment>
    );
  }

  return null;
};

AnalyticsLink.propTypes = {
  visible: PropTypes.bool.isRequired,
};

export default AnalyticsLink;
